// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    // MERCADO_PAGO_PUBLIC_KEY: 'TEST-ecfeb406-e048-414f-bc81-5c7f8b941b12',

    MERCADO_PAGO_PUBLIC_KEY: 'TEST-bf628309-9b39-42b3-884c-a74811c7dcad',
    // BACKEND_URL: 'https://portalbe.tukompa.com',


    BASE_URL: '', // prod,
    // BACKEND_URL :'http://192.168.42.170:8951'
    BACKEND_URL : 'https://ind12.holinsys.pe',
    // BACKEND_URL: 'https://indp02be.misolucioneswow.com',
    // GESTION_URL: 'http://localhost:4201'

    // BACKEND_URL_SMS: 'https://api.netelip.com/v1/sms/api.php'
    // BACKEND_URL: 'http://fake-be.com'
    // BACKEND_URL: 'http://192.168.1.2:3001'
    // BACKEND_URL: 'http://localhost:3001'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
